import _ from "lodash";
import { getItemById } from "@/utils/helper.js";

export default {
    getCurAuthByAction: (state, getters) => {
        let tmpObj = {};
        if (!state.userInfo.auth_points || !state.userInfo.auth_points.length) {
            return [];
        }
        tmpObj = getItemById(
            state.userInfo.auth_points,
            state.curAction,
            "action"
        );
        return tmpObj.child ? tmpObj.child : [];
    }
};



// WEBPACK FOOTER //
// ./src/store/getters.js